import ProxyListResult from './ProxyListResult'
export default ProxyListResult
